// Re-export for app-side imports. Source lives in libs/ui — see ADR 0038
// for the lib-promotion rationale.
export { useDebouncedValue } from '@kiips/ui';
